import { EnvironmentProviders } from "@angular/core";

import { provideNzIcons, NzIconModule } from "ng-zorro-antd/icon";
import {
  InfoCircleOutline,
  InfoCircleFill,
  CheckCircleOutline,
  CheckCircleFill,
  ExclamationCircleOutline,
  ExclamationCircleFill,
  CloseCircleOutline,
  CloseCircleFill,
  CloseOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  StarOutline,
  StarFill,
  HomeOutline,
  UserOutline,
  CompassOutline,
  TeamOutline,
  LinkOutline,
  SearchOutline,
  SettingOutline
} from "@ant-design/icons-angular/icons";

/**
 * Lista curada de ícones utilizados pelo design-system.
 * Se algum componente passar um nome fora desta lista (ex: via input icon() no Chip),
 * o consumidor deve estender registrando ícones adicionais (ex: provideNzIcons([...])).
 */
export const DESIGN_SYSTEM_ICONS = [
  InfoCircleOutline,
  InfoCircleFill,
  CheckCircleOutline,
  CheckCircleFill,
  ExclamationCircleOutline,
  ExclamationCircleFill,
  CloseCircleOutline,
  CloseCircleFill,
  CloseOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  StarOutline,
  StarFill,
  HomeOutline,
  UserOutline,
  CompassOutline,
  TeamOutline,
  LinkOutline,
  SearchOutline,
  SettingOutline
];

export const DESIGN_SYSTEM_ICON_IMPORTS = [NzIconModule.forRoot(DESIGN_SYSTEM_ICONS)];

/** Provider utilitário para uso em apps:
 * bootstrapApplication(AppComponent, { providers: [provideDesignSystemIcons()] })
 */
export function provideDesignSystemIcons(): EnvironmentProviders {
  return provideNzIcons(DESIGN_SYSTEM_ICONS);
}
